import { getContext } from 'svelte';
import { writable, derived } from 'svelte/store';

export const width = writable(404);
export const height = writable(720);
export const pixelRatio = writable(1); //window.devicePixelRatio
export const context = writable();
export const canvas = writable();
export const stream = writable();
export const streamFps = writable(25);
export const time = writable(0);

export const props = deriveObject({
  context,
  canvas,
  stream,
  streamFps,
  width,
  height,
  pixelRatio,
  time,
});

export const key = Symbol();

export const getState = () => {
  const api = getContext(key);
  return api.getState();
};

function deriveObject(obj) {
  const keys = Object.keys(obj);
  const list = keys.map((key) => {
    return obj[key];
  });

  return derived(list, (array) => {
    return array.reduce((dict, value, i) => {
      dict[keys[i]] = value;
      return dict;
    }, {});
  });
}
